export default {
    values: {
        'Resource Manager': 'Gestor de Recursos',
        'Resources Manager': 'Gestor de Recursos',
        'ALL RESOURCES': 'TODOS OS RECURSOS',
        'New resource': 'Novo recurso',
        'New Resource': 'Novo Recurso',
        'Resource Code': 'Código do Recurso',
        Name: 'Nome',
        Description: 'Descrição',
        Responsible: 'Responsável',
        'Resource Type': 'Tipo de recurso',
        'Affiliated to': 'Afiliado a',
        'Nameless Resource': 'Recurso não nomeado',
        'Nameless Res': 'Recurso sem nome',
        'There are no resources yet': 'Ainda não há recursos',
        'There are no resource types yet': 'Ainda não há tipos de recurso',
        'There are no channels assigned to this resource.': 'Não há canais associados a este recurso.',
        'THERE ARE NO CHANNELS ASSIGNED TO THIS RESOURCE.': 'NÃO HÁ CANAIS ASSOCIADOS A ESTE RECURSO.',
        'Create new resource': 'Criar novo recurso',
        'Create new resource type': 'Criar novo tipo recurso',
        Creating: 'Criando',
        Create: 'Criar',
        Close: 'Fechar',
        Extensions: 'Extensões',
        'Descriptions or instructions': 'Descrições e instruções',
        'Basic Info': 'Informações Básicas',
        Cancel: 'Cancelar',
        Save: 'Salvar',
        Saving: 'Salvando',
        'RESOURCE TYPE': 'TIPO DE RECURSO',
        LOCATION: 'LOCALIZAÇÃO',
        'Delete resource': 'Deletar recurso',
        // 'Generic Resource Manager': 'Gestor de recursos genérico',
        'Resource Basic Informations': 'Informações Básicas de Recurso',
        Resource: 'Recurso',
        'Duplicated resource code': 'Código de recurso duplicado',
        'Delete Resource': 'Deletar Recurso',
        'This action cannot be undone.': 'Esta ação não pode ser desfeita.',
        'Features that read this list will be affected.': 'Funcionalidades que utilizam esta lista serão afetadas.',
        'If you really want to delete the resource, type': 'Se realmente quer deletar o recurso, digite',
        'in the field below before completing the action:': 'no campo abaixo antes de completar a ação:',
        'Are you sure you want remove the resource': 'Tem certeza que quer remover o recurso',
        'Confirm deletion': 'Confirmar deleção',
        'No, I do not': 'Não tenho certeza',
        'Update Avatar': 'Atualizar Avatar',
        'Edit Avatar': 'Editar Avatar',
        'YOU DO NOT HAVE ACCESS PERMISSION.': 'VOCÊ NÃO POSSUI PERMISSÃO DE ACESSO.',
        'If you really want to delete the avatar, type': 'Se realmente quer deletar o avatar, digite',
        'Are you sure you want remove the avatar': 'Tem certeza que quer remover o avatar',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE RESOURCE MANAGER.':
            'VOCÊ NÃO POSSUI PERMISSÃO PARA ACESSAR O GESTOR DE RECURSO.',
        NAME: 'NOME',
        'PRODUCT ADDED': 'PRODUTOS VINCULADOS',
        'AFFILIATED TO': 'AFILIADO A',
        EXTENSIONS: 'EXTENSÕES',
        RESPONSIBLE: 'RESPONSÁVEL',
        'RESOURCE CODE': 'CÓDIGO DO RECURSO',
        Filters: 'Filtros',
        'No affiliated resources': 'Sem recursos afiliados',
        'AFFILIATED RESOURCES': 'RECURSOS AFILIADOS',
        'The image should not exceed 1MB. Accepted types are PNG, JPEG, and GIF.':
            'A imagem não pode exceder 1MB. Os tipos aceitos são PNG, JPEG e GIF.',
        'Name helps to identify resources.': 'O nome ajuda a identificar recursos.',
        'Code is used to identify resources.': 'O código é utilizado para identificar recursos.',
        'Information about this resource.': 'Informações sobre o recurso.',
        'The person who is responsible for this resource.': 'A pessoa que é responsável por esse recurso.',
        'How this resource is classified.': 'Como este recurso é classificado.',
        'Another resource to be associated to.': 'Outro recurso para se associar.',
        'Resource informations': 'Informações de recurso',
        'Restore Defaults': 'Restaurar padrões',
        Apply: 'Aplicar',
        'Resource deleted': 'Recurso deletado',
        'Avatar deleted': 'Avatar deletado',

        // RESOURCE TYPE CONFIGURATION
        'New Resource Type': 'Novo Tipo de Recurso',
        'Resources Types': 'Tipos de Recursos',
        'Resource Type name': 'Nome do Tipo de Recurso',
        'The name is used to identify the resource type.': 'O nome é usado para identificar o tipo de recurso',
        'Edit Resource Type': 'Editar Tipo de Recurso',
        'Are you sure you want remove the resource type': 'Você tem certeza que quer remover o tipo de recurso',
        'Delete resource type': 'Excluir tipo de recurso',
        'If you really want to delete the resource type, type':
            'Se você realmente quiser excluir o tipo de recurso, digite',
        'Resource type deleted succesfully.': 'Tipo de Recurso excluído com sucesso.',
        'Resource Types': 'Tipos de Recurso',
        'Resource type created successfully.': 'Tipo de recurso criado com sucesso.',
        'Unable to create resource type.': 'Não foi possível criar tipo de recurso.',
        'Unable to fetch resource types.': 'Não foi possível recuperar os tipos de recurso.',
        'It provides a standardized format for defining dynamic attributes, such as Channel Number, which returns a numeric scalar value.':
            'Ele fornece um formato padronizado para definir atributos dinâmicos, como Número do Canal, que retorna um valor escalar numérico.',
        'Show the basic information about the resource.': 'Mostrar as informações básicas sobre o recurso.',
        'No dependent extensions': 'Sem extensões dependentes',
        EXTENSION: 'EXTENSÃO',
        'DEPENDENT EXTENSIONS': 'EXTENSÕES DEPENDENTES',

        // RESOURCE GROUP CONFIGURATION
        Users: 'Usuários',
        USERS: 'USUÁRIOS',
        users: 'USUÁRIOS',
        TYPE: 'TIPO',
        'RESOURCE TYPES': 'TIPOS DE RECURSO',
        'Resource Groups': 'Grupos de Recurso',
        'Resources Groups': 'Grupos de Recursos',
        'New Resource Group': 'Novo Grupo de Recurso',
        'Create a new resource type': 'Criar um novo tipo de recurso',
        'Resource types': 'Tipos de recurso',
        'Group name': 'Nome do grupo',
        'If you really want to delete the resource group, type':
            'Se você realmente quer excluir esse grupo de recursos, digite',
        'Resource group deleted succesfully.': 'Grupo de recursos deletado com sucesso.',
        'Are you sure you want remove the resource group': 'Você tem certeza que quer remover o grupo de recurso',
        'Delete resource group': 'Excluir grupo de recurso',
        'Unable to fetch resource groups.': 'Incapaz de listar grupos de recurso.',
        'Unable to fetch live users.': 'Incapaz de listar usuários do live.',
        'No groups have been added.': 'Nenhum grupo foi adicionado.',
        'Resource group created succesfully.': 'Grupo de recurso criado com sucesso.',
        Delete: 'Excluir',
        'YOU DO NOT HAVE PERMISSION TO ACCESS THE RESOURCE GROUP CONFIGURATION.':
            'VOCÊ NÃO POSSUI PERMISSÃO PARA ACESSAR AS CONFIGURAÇÕES DE GRUPO DE RECURSOS.',
        CODE: 'CÓDIGO',
        'Back to resource ': 'Voltar para o recurso ',
        'Back to configuration': 'Voltar para configuração',
        Groups: 'Grupos',
        'Delete avatar': 'Deletar avatar',
        'Delete Avatar': 'Deletar Avatar',
        resources: 'recursos'
    }
}
